<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th v-if="showCheckbox">
            <input type="checkbox" @change="toggleAll" :checked="isAllSelected" />
          </th>
          <th>Bill Number</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Due Date</th>
          <th>Amount</th>
          <th>Status</th>
          <th class="text-center" v-if="showActions">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td v-if="showCheckbox">
            <input type="checkbox" :value="item.id" v-model="localSelected" />
          </td>
          <td>{{ item.bill_number }}</td>
          <td>{{ formatDate(item.start_date) }}</td>
          <td>{{ formatDate(item.end_date) }}</td>
          <td>{{ formatDate(item.due_date) }}</td>
          <td>{{ item.amount }}</td>
          <td>
            <span :class="item.status === 'paid' ? 'badge bg-success' : 'badge bg-danger'">
              {{ item.status }}
            </span>
          </td>
          <td class="text-center" v-if="showActions">
            <button class="btn btn-primary btn-sm"
                    @click="$emit('printInvoice', item)"
                    :disabled="printingItemId === item.id"
                    title="Print">
                <i class="fas fa-print"></i>
            </button>
            <button v-if="item.status === 'paid'" 
                    class="btn btn-secondary btn-sm ms-1"
                    @click="$emit('printReceipt', item)"
                    :disabled="printingReceiptId === item.id"
                    title="Print Receipt">
                <i class="fas fa-print"></i>
            </button>
          </td>
        </tr>
        <tr v-if="!tableItems.length">
          <td :colspan="columnCount" class="text-center">No subscriptions found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
  tableItems: { type: Array, required: true },
  selectedSubscriptions: { type: Array, default: () => [] },
  showCheckbox: { type: Boolean, default: true },
  showActions: { type: Boolean, default: false },
  printingItemId: { type: [Number, String], default: null },
  printingReceiptId: { type: [Number, String], default: null }
});

const emit = defineEmits(['update:selectedSubscriptions', 'printInvoice', 'printReceipt']);

const localSelected = ref([...props.selectedSubscriptions]);

watch(localSelected, (newVal) => {
  emit('update:selectedSubscriptions', newVal);
});

watch(() => props.selectedSubscriptions, (newVal) => {
  if (JSON.stringify(newVal) !== JSON.stringify(localSelected.value)) {
    localSelected.value = [...newVal];
  }
}, { deep: true });

const isAllSelected = computed(() => {
    return props.tableItems.length > 0 && localSelected.value.length === props.tableItems.length;
});

const toggleAll = (event) => {
    if (event.target.checked) {
        localSelected.value = props.tableItems.map(item => item.id);
        return;
    }
    localSelected.value = [];
};

const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString();
};

const columnCount = computed(() => {
    let count = 6;
    if (props.showCheckbox) count++;
    if (props.showActions) count++;
    return count;
});
</script>
